import React, { useState } from "react";
import { Container } from "./styles";
import { Logo } from "../../Components/imgs";
import { useLocation } from "react-router";
import { BiMenu } from "react-icons/bi";
import { CgClose } from "react-icons/cg";

export default function Menu() {
	const { pathname } = useLocation();

	const [menuActive, setMenuActive] = useState(false);

	const whatsappMessage = encodeURIComponent(
		"Oii tudo bem? Quero agendar minha análise"
	);

	const whatsappLink = `https://wa.me/5541984146397?text=${whatsappMessage}%21`;

	return (
		<Container>
			<div className="wrapper">
				<div>
					<a href="/">
						<img src={Logo} alt="logo dna for performance" className="logo" />
					</a>
				</div>
				<div className="btns_menu">
					<li>
						<a href="/" id={pathname === "/" ? "active" : " "}>
							Home
						</a>
					</li>
					<li>
						<a
							href="/quemsomos"
							id={pathname === "/quemsomos" ? "active" : " "}>
							Quem somos
						</a>
					</li>
					<li>
						<a href="/produtos" id={pathname === "/produtos" ? "active" : " "}>
							Produtos
						</a>
					</li>
					<li>
						<a href="/blog" id={pathname === "/blog" ? "active" : " "}>
							Blog
						</a>
					</li>
					<li>
						<a href={whatsappLink} target="_blank" rel="noreferrer">
							Agende sua análise
						</a>
					</li>
				</div>

				<div className="hamMenu">
					<button onClick={() => setMenuActive(!menuActive)}>
						{menuActive ? <CgClose size={50} /> : <BiMenu size={50} />}
					</button>
				</div>

				<div className={`mobileMenu ${menuActive === false ? "close" : " "}`}>
					<ul>
						<li>
							<a href="/">Home</a>
						</li>
						<li>
							<a href="/quemsomos">Quem somos</a>
						</li>
						<li>
							<a href="/produtos">Produtos</a>
						</li>
						<li>
							<a href="blog">Blog</a>
						</li>
						<li>
							<a href={whatsappLink} target="_blank" rel="noreferrer">
								Agente sua análise
							</a>
						</li>
					</ul>
				</div>
			</div>
		</Container>
	);
}
